export default __webpack_public_path__ + "static/media/selamat6.b7733319.svg";